<template>
    <div class="content-table">
        <el-table :data="tableData" style="width: 100%" stripe empty-text=" ">
            <el-table-column type="index" :label="$t('operation.task.no')" align="center" width="80">
                <template slot-scope="scope">{{
            scope.$index + pageSize * (pageIndex - 1) + 1
        }}
                </template>
            </el-table-column>
            <el-table-column prop="userName" :label="$t('operation.task.patrolServer')" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="taskName" :label="$t('operation.task.taskName')" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="cameraNos" :label="$t('operation.task.numberOfChannels')">

                <template slot-scope="scope">
                    {{ scope.row.cameraNos ? scope.row.cameraNos.length : 0 }}
                </template>
            </el-table-column>
            <el-table-column prop="enable" :label="$t('operation.task.status')">

                <template slot-scope="scope">
                    <el-switch @change="tdStatusChange($event, scope.row)" v-model="scope.row.enable" :active-value="1"
                        :inactive-value="0"></el-switch>
                </template>
            </el-table-column>
            <el-table-column :label="$t('common.action')" width="200">

                <template slot-scope="scope">
                    <span class="operator-txt blue-txt" @click="clickEdit(scope.row, 'taskDetail')">{{
            $t('common.details')
        }}</span>
                    <span class="operator-txt green-txt" @click="clickEdit(scope.row, 'taskEdit')"
                        v-permission="taskListEdit">{{
            $t('common.edit')
        }}</span>
                    <span class="error-txt" @click="clickTdDelete(scope.row)" v-permission="taskListDelete">{{
                        $t('common.delete') }}</span>
                </template>
            </el-table-column>
        </el-table>

        <ActionPwdModal ref="actionPwdRef" @actionSave="deleteData"></ActionPwdModal>
    </div>
</template>

<script>
import ActionPwdModal from '@/components/actionPwdModal.vue'
import Cookies from "js-cookie";
export default {
    props: {
        tableData: {
            type: Array, default: () => ([])
        },
        pageIndex: {
            type: Number, default: 1
        },
        pageSize: {
            type: Number, default: 10
        }
    },
    components: {
        ActionPwdModal
    },
    data() {
        return {
            monitorId: Number(Cookies.get("monitorId")),
            currentRowData: {}
        }
    },
    methods: {
        clickTdDelete(row) {
            this.currentRowData = row;
            this.$refs.actionPwdRef.open();
        },
        deleteData(password) {
            this.$Http.delete(`${this.$Api.captureTaskBatchDelete}/${this.monitorId}/${password}`, [this.currentRowData.taskId], true).then(res => {
                if (res.success) {
                    this.$refs.actionPwdRef.close();
                    this.$message.success(vm.$t('common.successful'));
                    this.$emit('reloadData');
                } else {
                    this.$message.error(res.message)
                }
            });
        },
        clickEdit(row, name) {
            sessionStorage.setItem('row', JSON.stringify(row));
            this.$router.push({ name, params: { id: row.taskId } });
        },
        tdStatusChange(val, row) {
            this.$Http.put(`${this.$Api.captureTaskBatchEnable}/${this.monitorId}/${val}`, [row.taskId], true).then(res => {
                if (res.success) {
                    this.$message.success(vm.$t('common.successful'));
                } else {
                    this.$message.error(res.message)
                }
            });
        }
    }
}

</script>

<style scoped lang="scss">
.operator-txt {
    margin-right: 16px;
}
</style>